module.exports = __webpack_public_path__ + "aaeffaf205b9bbb09920089a14dbe9e8.woff2";